<template>
  <v-app class="wrapper">
    <layout-grid/>

    <no-access v-if="isAuthenticated && !hasAppAccess"/>
    <router-view v-else/>

    <error-dialog
        :room-name-prop="roomName"/>
  </v-app>
</template>
<script>
import LayoutGrid from '@/components/LayoutGrid';
import NoAccess from '@/views/NoAccess';
import ErrorDialog from '@/components/ErrorDialog';
import {mapGetters} from 'vuex';

export default {
  name: 'App',
  components: {NoAccess, LayoutGrid, ErrorDialog},
  computed: {
    ...mapGetters('auth', ['hasAppAccess', 'isAuthenticated']),
    ...mapGetters('room', ['roomName'])
  }
};
</script>
<style>
html {
  overflow: auto;
}
</style>
